/**
 * Scroll Depth Tracking
 * Dispara evento scroll_depth a cada marco: 25%, 50%, 75%, 90%, 100%
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { track } from '@/lib/analytics';
import { Events } from '@/lib/analytics-events';

const MILESTONES = [25, 50, 75, 90, 100];

export function useScrollTracking() {
  const location = useLocation();
  const fired = useRef<Set<number>>(new Set());

  useEffect(() => {
    fired.current.clear();

    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      const percent = Math.round((scrollTop / docHeight) * 100);

      for (const milestone of MILESTONES) {
        if (percent >= milestone && !fired.current.has(milestone)) {
          fired.current.add(milestone);
          track(Events.scrollDepth(milestone, location.pathname));
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);
}
